import AbsComponent from "./AbsComponent";

export default class SearchFilterJob extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='',_l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
        this.setting();
    }

    setting(){
        axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/jobs.json`
        })
        .then( (_res) => {
            _res.data.unshift({id: "all", name: this.l10n.all});

            let tempJobData = {};

            let template = _res.data.map( (it, idx) => {

                tempJobData[it.id] = it.code;

                return `
                <li>
                    <input type="radio" id="job_item_${it.id}" name="job_item" value="${it.id}" ${idx===0?`checked=""`:``}>
                    <label for="job_item_${it.id}">${it.name}</label>
                </li>`;
            }).join('');
            jQuery(this.el + ' ul').append(template);

            this.store.dispatch(this.actions.setJobData(tempJobData));

            this.addEvents();
            this.render();
        })
        .catch( (error) => {
            console.log( 'error---', error.response );
        })
        .then( (d) => {
        } );
    }

    addEvents(){
        jQuery(this.el + ' input').on('change', e =>{
            const jobId = $(this.el + ' input[name="job_item"]:checked').val();
            this.router.goMultiParam({job: jobId==='all'? '': jobId, page: 1});
        });

        jQuery('.character-search-wrap .btn-filter').on('click', e =>{
            $('.job-filter-list').toggle();
        });

        jQuery('#container').on('click', e =>{
            if ( !$(e.target).hasClass('job-filter-list') && !$(e.target).hasClass('btn-filter') ) {
                $('.job-filter-list').toggle(false);
            }
        });
    }

} // end of class